import React from 'react';
export const WhatsAppButton = () => {
  return <a href="https://wa.me/13479909488?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20cita%20%E2%9C%A8" target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" className="group fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[9000] flex items-center justify-center" style={{
    animation: 'wa-float 3s ease-in-out infinite'
  }} data-id="element-485">
      {/* Pulsing rings */}
      <span className="absolute inset-0 rounded-full" style={{
      background: 'rgba(196, 165, 116, 0.45)',
      animation: 'wa-ping 2.2s cubic-bezier(0, 0, 0.2, 1) infinite'
    }} aria-hidden="true" data-id="element-486" />
      <span className="absolute inset-0 rounded-full" style={{
      background: 'rgba(196, 165, 116, 0.3)',
      animation: 'wa-ping 2.2s cubic-bezier(0, 0, 0.2, 1) infinite 1.1s'
    }} aria-hidden="true" data-id="element-487" />

      {/* Main button */}
      <span className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110" style={{
      background: 'linear-gradient(135deg, #E8D2B0 0%, #D4B488 45%, #C2A06E 75%, #A8895C 100%)',
      boxShadow: '0 6px 20px rgba(168, 137, 92, 0.45), inset 0 1px 0 rgba(255, 248, 235, 0.55), inset 0 -2px 4px rgba(120, 90, 50, 0.3)'
    }} data-id="element-488">
        {/* WhatsApp glyph */}
        <svg viewBox="0 0 32 32" className="w-7 h-7 sm:w-8 sm:h-8" fill="#FFFFFF" aria-hidden="true" data-id="element-489">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.05 31.3l6.124-1.958A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.594c-.386 1.09-1.92 1.994-3.142 2.258-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.166-3.424 1.636-3.904.386-.394.846-.574 1.328-.574.156 0 .296.008.424.014.382.016.574.038.826.64.314.756 1.078 2.62 1.17 2.812.094.192.188.452.06.762-.12.32-.226.46-.43.708-.214.248-.42.438-.634.704-.196.232-.418.484-.172.91.246.418 1.094 1.804 2.35 2.922 1.62 1.44 2.93 1.9 3.402 2.096.35.146.768.112 1.022-.16.322-.35.72-.93 1.124-1.5.286-.408.648-.458 1.028-.316.388.134 2.45 1.156 2.872 1.366.422.21.7.312.804.486.102.176.102 1.01-.284 2.09z" data-id="element-490" />
        </svg>
      </span>

      <style data-id="element-491">{`
        @keyframes wa-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes wa-ping {
          0% { transform: scale(1); opacity: 0.7; }
          75%, 100% { transform: scale(1.9); opacity: 0; }
        }
      `}</style>
    </a>;
};